import publicCta from '../content/publicCta.json';
import { getWhatsAppUrl } from '../constants/whatsappContact.js';

export function getVacacionWhatsAppHref(sede) {
  if (!sede) return null;
  const topic = publicCta.whatsappTopics?.find((t) => t.id === 'sede-vacacional');
  const base = topic?.message || 'Hola, quiero más información sobre la sede vacacional.';
  const message = `${base} (${sede.titulo}${sede.ubicacion ? ` — ${sede.ubicacion}` : ''}).`;
  return getWhatsAppUrl(message);
}
